import React, { createContext } from "react";

// TODO: We're hard coding this to be true because we still haven't cleaned up the old nav code (pre-2022)
// We want to eventually remove all references to this context and all pre-2022 Nav code.
export const NavigationContext = createContext({
  use2022Nav: true,
  providerInitialized: true,
});

export const NavigationProvider = ({ children, use2022Nav }) => {
  return (
    <NavigationContext.Provider
      value={{
        use2022Nav,
        providerInitialized: true,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};
